import React, { FC } from "react";

import { getHrefLang } from "../../utils/i18n";
import { getKeys } from "../../utils/object";
import { getMetadataUrl } from "./get-metadata-url";

export type SeoProps = {
  title: string | null;
  pageTitle: string | null;
  description: string | null;
  image: string | null;
  htmlLang: string;
  path: string;
  alternateUrls: Record<string, string>;
  noIndex: boolean | null;
  noFollow: boolean | null;
};

export const SEO: FC<SeoProps> = ({
  title,
  description,
  image,
  path: url,
  htmlLang,
  alternateUrls,
  noIndex,
  noFollow,
}) => {
  return (
    <>
      <html lang={htmlLang} />
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {image && <meta name="image" content={image} />}

      <link rel="canonical" href={getMetadataUrl(url)} />
      {getKeys(alternateUrls).map((language, i) => (
        <link
          key={i}
          rel="alternate"
          hrefLang={getHrefLang(language)}
          href={getMetadataUrl(alternateUrls[language])}
        />
      ))}

      {/* Exclude page from search engines and search engines if requested */}
      {noIndex && noFollow && <meta name="robots" content="none" />}
      {noIndex && !noFollow && <meta name="robots" content="noindex" />}
      {!noIndex && noFollow && <meta name="robots" content="nofollow" />}
      {/* Socials tags */}
      {title && <meta property="og:title" content={title} />}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}

      {/* Twitter tags */}
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
    </>
  );
};
